import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=c7b7c7a0&"
import script from "./NavMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7b7c7a0')) {
      api.createRecord('c7b7c7a0', component.options)
    } else {
      api.reload('c7b7c7a0', component.options)
    }
    module.hot.accept("./NavMenuItem.vue?vue&type=template&id=c7b7c7a0&", function () {
      api.rerender('c7b7c7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/sidebar/NavMenuItem.vue"
export default component.exports